import React, { Component } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {reduxForm, getFormValues, SubmissionError } from 'redux-form';

import { bookingFormInitialValues } from '../store/reducers';
import { setStep, submitReservation, setReservationStatus, setCanContinue } from '../store/actions';
import { validatePhone } from '../api';
import {
	validateStep4FormValues,
	isContinueEnabled,
} from '../validators';
import {formatPrice, formatPriceNumber, inIframe, postMessageToParent} from '../utils';
import { isPackagesStepVisible } from '../apiHelpers';
import { PAYMENT_METHOD_WITHOUT_PAYMENT } from '../constants';
import ReservationStatus from '../enums/ReservationStatus';
import withLocalize from '../withLocalize';
import T from './Translate';

class Navbar extends Component {

	state = {
		isFullscreenLoading: false,
		isNavbarInitialized: false,
	};

	componentWillUnmount() {
		if (this.navbarResizeObserver) {
			this.navbarResizeObserver.disconnect();
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.recaptchaToken !== nextProps.recaptchaToken) {
			this.recaptchaDidResolve(nextProps.recaptchaToken);
		}
	}

	recaptchaDidResolve = async (token) => {
		const { dispatch } = this.props;

		try {
			const response = await dispatch(submitReservation(token));

			if (response.paymentGateway && response.paymentGateway.url) {
				// Přesměrování na platební bránu
				if (response.paymentGateway.inline && window._gopay !== undefined) {
					// inline varianta
					if (inIframe()) {
						postMessageToParent('redirectGopayInline', {
							gatewayUrl: response.paymentGateway.url,
							scriptUrl: response.paymentGateway.scriptUrl
						});
					} else if (window._gopay !== undefined) {
						window._gopay.checkout({gatewayUrl: response.paymentGateway.url, inline: true});
					} else {
						window.top.location.href = response.paymentGateway.url;
					}
				} else {
					window.top.location.href = response.paymentGateway.url; // nechceme případně zůstat v iframe
				}

			} else {
				if (response.errors) {
					const errors = Object.keys(response.errors);

					if (!errors[0]) {
						console.error("Server vrátil neočekávanou odpověď.", response);
					}

					dispatch(setReservationStatus(errors[0]));

				} else if (response.redirect && response.redirect.code === 200) {
					// Úspěšná rezervace
					if (response.redirect.url) {
						if (response.redirect.iframe) {
							// přesměrujeme v iframe
							window.location.href = response.redirect.url;
						} else {
							// přesměrujeme v hlavním okně
							window.top.location.href = response.redirect.url;
						}
					} else {
						dispatch(setReservationStatus(ReservationStatus.NO_GATE));
					}

				} else {
					console.error("Musí se ošetřit všechny návratové hodnoty.", response);
					dispatch(setReservationStatus(ReservationStatus.ERROR));
				}

				this.props.recaptcha.reset();
				this.setState({isFullscreenLoading: false});
				dispatch(setStep(6));
			}

		} catch (e) {
			console.error("Rezervace se nezdařila", e);
			this.props.recaptcha.reset();
			this.setState({isFullscreenLoading: false});
			dispatch(setReservationStatus(ReservationStatus.ERROR));
			dispatch(setStep(6));
		}
	};

	isStep3Visible = () => {
		const { app, packages, apiRoomsResponse, formValues } = this.props;

		if (app.package) {
			// Balíček již máme předvybraný
			return false;
		}

		const packageIds = apiRoomsResponse ? apiRoomsResponse.packageIds : null;
		return isPackagesStepVisible(packages, packageIds, formValues);
	};

	handleClickContinue = async () => {

		const { dispatch, step, formValues, isPaymentGatewayEnabled, translate: t, app } = this.props;

		if (!this.props.canContinue) {
			return;
		}

		if (step === 1 && !isContinueEnabled(formValues, step)) {
			window.alert(t('Navbar.continueError.step1'));
			return;

		} else if (step === 2 && !isContinueEnabled(formValues, step)) {
			window.alert(t('Navbar.continueError.step2'));
			return;

		} else if (step === 4) {
			validateStep4FormValues(formValues, true, app);

			// Autoritativní serverová validace telefonu přes endpoint.
			dispatch(setCanContinue(false));
			try {
				const result = await validatePhone({ app }, formValues.phone);

				if (!result.isValid) {
					throw new SubmissionError({ phone: 'validators.phone' });
				}

			} catch (e) {
				if (e instanceof SubmissionError) {
					throw e;
				}
				// Síťová chyba endpointu neblokuje rezervaci (formát už ohlídal regex výše).
				console.error('Validace telefonu přes endpoint selhala', e);
			} finally {
				dispatch(setCanContinue(true));
			}

		} else if (step === 5 && !isContinueEnabled(formValues, step, isPaymentGatewayEnabled)) {
			window.alert(t('Navbar.continueError.step5'));
			return;
		}

		let newStep = step + 1;

		if (newStep === 3 && !this.isStep3Visible()) {
			newStep = 4;
		}

		if (newStep === 6) {
			this.setState({ isFullscreenLoading: true });
			this.props.recaptcha.execute();

		} else {
			dispatch(setStep(newStep));
		}


	};

	handleClickGoBack = (e) => {
		e.preventDefault();

		if (!this.props.canContinue) {
			return;
		}

		const { dispatch, step } = this.props;
		let newStep = step - 1;

		if (newStep === 3 && !this.isStep3Visible()) {
			newStep = 2;
		}

		dispatch(setStep(newStep));
	};

	onNavbarInit = (el) => {
		if (el && !this.state.isNavbarInitialized) {
			this.setState({ isNavbarInitialized: true });
			this.navbarEl = el;

			// Výška se mění i po načtení (styly vzhledu, fonty), proto ji posíláme znovu
			const sendNavbarHeight = () => postMessageToParent('navbarHeight', el.getBoundingClientRect().height);
			sendNavbarHeight();
			if (window.ResizeObserver) {
				this.navbarResizeObserver = new window.ResizeObserver(sendNavbarHeight);
				this.navbarResizeObserver.observe(el, { box: 'border-box' });
			}

			window.addEventListener('message', (e) => {
				this.onParentScroll(e);
			});
		}
	};

	onParentScroll = (e) => {
		if (e.data && e.data.type === 'scroll') {
			this.navbarEl.style.top = e.data.value + 'px';
			this.navbarEl.style.bottom = 'initial';
		}
	};

	getLabels = () => {
		const {
			step,
			isPaymentGatewayEnabled,
			formValues,
			isAdvancePaymentRequired,
			translate: t,
		} = this.props;

		let totalPriceLabel = t('Navbar.totalPriceLabel');
		let continueButtonLabel = t('Navbar.continue');

		if (step === 5 && isPaymentGatewayEnabled &&
			(isAdvancePaymentRequired || formValues.paymentMethod !== PAYMENT_METHOD_WITHOUT_PAYMENT) ) {
			totalPriceLabel = t('Navbar.priceToPay');
			continueButtonLabel = t('Navbar.reserveAndPay');

		} else if (step === 5) {
			continueButtonLabel = t('Navbar.reserve');
		}

		return { continueButtonLabel, totalPriceLabel };
	};

	isPriceToPayShown = () => {
		const { isAdvancePaymentRequired, advancePaymentPercentage, formValues } = this.props;

		return (isAdvancePaymentRequired || (advancePaymentPercentage < 100 && formValues.advancePaymentOnly)) && formValues.paymentMethod !== PAYMENT_METHOD_WITHOUT_PAYMENT;
	};

	getPrice = () => {
		const { totalPrice, priceToPay, formValues } = this.props;

		return formatPrice(this.isPriceToPayShown() ? priceToPay : totalPrice, formValues.currency);
	};

	/**
	 * Celková cena s microdaty pro Google, ten ji čte z viditelného čísla.
	 */
	renderGooglePrice = () => {
		const { totalPrice, formValues: { currency } } = this.props;

		return (
			<span className="navbar__price" itemProp="priceSpecification" itemScope itemType="https://schema.org/CompoundPriceSpecification">
				<meta itemProp="priceCurrency" content={currency.code} />
				{currency.position === 'before' && currency.symbol}
				<span itemProp="price">{formatPriceNumber(totalPrice, currency)}</span>
				{currency.position === 'after' && ' ' + currency.symbol}
			</span>
		);
	};

	render() {
		const {
			handleSubmit,
			step,
			formValues,
			isPaymentGatewayEnabled,
			canContinue,
			app,
		} = this.props;

		if (step > 5) return null;

		const { continueButtonLabel, totalPriceLabel } = this.getLabels();

		// Crawler Googlu se tímto tlačítkem dostane z landingu na Step2, kde čte cenu
		const isCriticalPath = step === 1 && !app.googleSoldOut;

		// Záloha není cena pobytu, takže ji Googlu neoznačujeme
		const isGooglePrice = step === 2 && !this.isPriceToPayShown();

		return (
            <nav className="navbar" ref={ el => this.onNavbarInit(el) }>
				<div className="navbar__row">
					{isGooglePrice ?
					<div className="navbar__price-container" itemProp="makesOffer" itemScope itemType="https://schema.org/Offer">
						{totalPriceLabel}<br />
						{this.renderGooglePrice()}
					</div>
					:
					<div className="navbar__price-container">
						{totalPriceLabel}<br />
						<span className="navbar__price">{this.getPrice()}</span>
					</div>
					}
					<div className="navbar__buttons-container">
						{step > 1 &&
						<button
							className="button navbar__button-back"
							onClick={this.handleClickGoBack}
							disabled={!canContinue}
						>
							<T id="Navbar.back" />
						</button>
						}
						<button
							className={`button navbar__button-next ${(!isContinueEnabled(formValues, step, isPaymentGatewayEnabled, app) || !canContinue) ? 'navbar__button-next--disabled' : ''}`}
							onClick={handleSubmit(this.handleClickContinue)}
							disabled={!canContinue}
							data-nav-criticalpath={isCriticalPath ? 'true' : undefined}
							data-nav-interactiontype={isCriticalPath ? 'CLICK' : undefined}
							data-nav-interactionorder={isCriticalPath ? '1' : undefined}
						>
							{continueButtonLabel}
						</button>
					</div>
				</div>

				{this.state.isFullscreenLoading &&
				<div className="fullscreen-loader">
					<div className="loader loader--large"/>
				</div>
				}

            </nav>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	withRouter,
	connect((state) => ({
		app: state.app,
		canContinue: state.app.canContinue,
		step: state.app.step,
		formValues: getFormValues('bookingForm')(state),
		totalPrice: state.app.totalPrice,
		priceToPay: state.app.priceToPay,
		isPaymentGatewayEnabled: state.app.isPaymentGatewayEnabled,
		isAdvancePaymentRequired: state.app.isAdvancePaymentRequired,
		advancePaymentPercentage: state.app.advancePaymentPercentage,
		packages: state.app.packages || {},
		apiRoomsResponse: state.app.apiRoomsResponse,
	})),
	withLocalize,
)(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar.jsx